import { Link } from 'react-router-dom';
//import FooterLogo from './FooterLogo';

export default function Footer() {
  return (
    <footer className="site-footer">
      <Link to="/" className="footer-brand">
      </Link>

      <div className="footer-center">
        <Link to="/nursery">The Nursery</Link>
        <Link to="/vision">The Vision</Link>
        <Link to="/portfolio">Portfolio</Link>
        <Link to="/about">About Us</Link>
        <Link to="/contact">Contact</Link>
      </div>

      <div className="footer-right">
        <span>Ela Shapira</span><br />
        <span className="pink">Startup Doula</span><br />
        <span style={{ fontSize: '7pt', color: '#aaa' }}>
          © {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
}
